import { render, staticRenderFns } from "./EmbedShell.vue?vue&type=template&id=6c1cd438&scoped=true"
import script from "./EmbedShell.vue?vue&type=script&lang=js"
export * from "./EmbedShell.vue?vue&type=script&lang=js"
import style0 from "./EmbedShell.vue?vue&type=style&index=0&id=6c1cd438&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1cd438",
  null
  
)

export default component.exports